import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getHsCompaniesExpiring } from "../../services/apiClient.js";
import { formatDate } from "../../utils/date.js";
import WorkflowReport from "./WorkflowReport.jsx";

// RDR Health & Safety, live: the Company PL Expiry Alert (±1 month window,
// red once expired — legacy admin-only section) above the H&S rule lines.

function RdrHsReport() {
  const [companies, setCompanies] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getHsCompaniesExpiring().then(setCompanies).catch(() => {});
  }, []);

  // Click a company → its System Data entry, editor open, ready to fix the
  // expiry date (deep-link: ?entity=<type>-companies&edit=<id>).
  const openCompany = (co) =>
    navigate(`/admin/system-data?entity=${co.company_type}-companies&edit=${co.id}`);

  return (
    <>
      {/* Always visible (2026-07-12) — an empty alert list is GOOD NEWS worth
          showing, and a section that vanishes reads as unimplemented. */}
      {companies ? (
        <div className="placeholder-panel">
          <div className="text-uppercase fw-semibold small text-muted pb-1 border-bottom" style={{ letterSpacing: "0.06em" }}>
            Company PL Expiry Alert (±1 month)
          </div>
          {companies.map((co) => (
            <div
              key={co.id}
              role="button"
              className="d-flex flex-wrap justify-content-between column-gap-3 py-1 border-bottom clickable"
              data-hint="Open this company in System Data to update its public liability expiry"
              onClick={() => openCompany(co)}
            >
              <span className={co.expired ? "text-danger fw-semibold" : ""}>
                {co.name}
                {/* Company notes ride along (legacy showed Comments as the RDR note). */}
                {co.comments ? (
                  <span className="text-muted fw-normal small ms-2">— {co.comments}</span>
                ) : null}
              </span>
              <span className={co.expired ? "text-danger fw-semibold" : "text-muted"}>
                {co.expired ? "EXPIRED " : "expires "}{formatDate(co.expiry)}
              </span>
            </div>
          ))}
          {companies.length === 0 ? (
            <div className="py-1 text-muted">No public liability expiring within a month.</div>
          ) : null}
        </div>
      ) : null}
      <WorkflowReport group="hs" />
    </>
  );
}

export default RdrHsReport;
